import store from '../Store'
import { history } from '../Store'
import { matchPath } from 'react-router'
export const authPaths = ['/register', '/login', '/passwordLogin']
export const flowPaths = [
  '/bewoners',
  '/huurintentie',
  '/huurcontract',
  '/inkomsten',
  '/documenten',
  '/overzicht',
  '/bedankt',
  '/start',
]
import * as ts from '../services/translationService'
import { dump } from './debugService'
import { GENERAL_STEPS, VISIT_REQUEST_STEPS, CANDIDACY_REQUEST_STEPS, getCurrentStepType } from './stepService'

export const getStepperRoutes = (step = 0, zipCode) => {
  const stepType = getCurrentStepType(step)

  const items = [
    {
      content: ts.stepResidents(),
      to: `/bewoners`,
      stepTypes: isBrusselsZipCode(zipCode)
        ? [GENERAL_STEPS, CANDIDACY_REQUEST_STEPS]
        : [GENERAL_STEPS, VISIT_REQUEST_STEPS, CANDIDACY_REQUEST_STEPS],
      visible: true,
    },
    {
      content: ts.stepContract(),
      to: `/huurcontract`,
      stepTypes: [GENERAL_STEPS, CANDIDACY_REQUEST_STEPS],
      visible: true,
    },
    {
      content: ts.stepRentIntention(),
      to: `/huurintentie`,
      stepTypes: [GENERAL_STEPS, VISIT_REQUEST_STEPS, CANDIDACY_REQUEST_STEPS],
      visible: true,
    },
    {
      content: ts.stepIncome(),
      to: `/inkomsten`,
      stepTypes: [GENERAL_STEPS, VISIT_REQUEST_STEPS, CANDIDACY_REQUEST_STEPS],
      visible: true,
    },
    {
      content: ts.stepDocuments(),
      to: `/documenten`,
      stepTypes: [GENERAL_STEPS, CANDIDACY_REQUEST_STEPS],
      visible: true,
    },
    {
      content: ts.stepConfirm(),
      to: `/overzicht`,
      stepTypes: [VISIT_REQUEST_STEPS, CANDIDACY_REQUEST_STEPS],
      visible: true,
    },
    {
      content: ts.stepProfile(),
      to: `/profiel`,
      stepTypes: [GENERAL_STEPS],
      visible: false,
    },
  ]
  return items.filter(i => i.stepTypes.includes(stepType))
}

export const getPrefixPath = () => {
  const propertyId = getCurrentPropertyParam()
  if (propertyId) {
    return `/property/${propertyId}`
  } else {
    return ''
  }
}

export const goToPageInternal = (path, { replace, redirectBack } = {}) => {
  if (replace) {
    history.replace({
      pathname: path,
      state: redirectBack && { from: path },
    })
  } else {
    history.push({
      pathname: path,
      state: redirectBack && { from: getRawPath() },
    })
  }
}

export const goBack = () => {
  history.goBack()
}

export const goToPath = url => {
  goToPageInternal(url)
}

export const goToRegisterPage = options => {
  goToPageInternal(getPrefixPath() + `/register`, options)
}

export const goToRegisterPasswordPage = options => {
  goToPageInternal(getPrefixPath() + `/registerPassword`, options)
}

export const goToRegisterEmailPage = options => {
  goToPageInternal(getPrefixPath() + `/registerEmail`, options)
}

export const gotToPhoneNumberVerificationPage = options => {
  goToPageInternal(getPrefixPath() + '/verify-phone', options)
}

export const goToEmailVerificationPage = options => {
  goToPageInternal(getPrefixPath() + '/verify-email', options)
}

export const goToProfilePage = (tab = '', options) => {
  goToPageInternal(`/profiel${tab !== '' ? `/${tab}` : ''}`, options)
}

export const goToOverviewPage = options => {
  goToPageInternal(getPrefixPath() + `/overzicht`, options)
}

export const goToOverviewPageWithOutProperty = options => {
  goToPageInternal('/overzicht', options)
}

export const goToForgotPasswordPage = options => {
  goToPageInternal(getPrefixPath() + `/forgotPassword`, options)
}

export const goToLoginPage = options => {
  goToPageInternal(getPrefixPath() + `/login`, options)
}

export const goToResetPasswordRequestedPage = options => {
  goToPageInternal(getPrefixPath() + `/resetRequested/sms`, options)
}

export const goToResetPasswordLinkRequestedPage = options => {
  goToPageInternal(getPrefixPath() + `/resetRequested/email`, options)
}

export const goToResetPasswordPage = (resetToken, options) => {
  goToPageInternal(getPrefixPath() + `/resetPassword/${resetToken}`, options)
}

export const goToResetPasswordSuccessPage = options => {
  goToPageInternal(getPrefixPath() + `/success`, options)
}

export const goToThankyouPage = options => {
  goToPageInternal(getPrefixPath() + `/bedankt`, options)
}

export const goToPage = page => {
  goToPageInternal(getPrefixPath() + page)
}

export const getRawPath = () => {
  return history.location.pathname
}

export const getCurrentPath = () => {
  let pathname = history.location.pathname
  const prefixPath = getPrefixPath()
  const index = pathname.indexOf(prefixPath)
  if (index > -1) {
    pathname = pathname.substr(prefixPath.length)
  }
  if (pathname === '') {
    pathname = '/'
  }
  return pathname
}

export const goToPasswordLoginPage = () => {
  goToPageInternal(getPrefixPath() + '/passwordLogin')
}

export const goToNotFoundPage = () => {
  goToPageInternal('/overview')
}

export const getCurrentPropertyParam = () => {
  const match = matchPath(history.location.pathname, {
    path: '/property/:id/',
    exact: false,
    strict: false,
  })
  return match && match.params && match.params.id
}

export const goToNextFlowPage = (step, destiny = 1, options) => {
  const currentPath = getCurrentPath()
  const flowPaths = getStepperRoutes(step)
  const currentPathIndex = flowPaths.findIndex(path => path.to === currentPath)
  const nextPathIndex = currentPathIndex + destiny

  dump({ flowPaths: flowPaths[nextPathIndex] })

  if (flowPaths[nextPathIndex]) {
    goToPageInternal(getPrefixPath() + flowPaths[nextPathIndex].to, options)
  }
}

export const goTo404 = options => {
  goToPageInternal('/404', options)
}
export const goToPropertyNotFound = options => {
  goToPageInternal('/property-not-found', options)
}

export const goToResidentsPage = options => {
  goToPageInternal(getPrefixPath() + '/bewoners', options)
}

export const goToRentIntentionPage = options => {
  goToPageInternal(getPrefixPath() + '/huurintentie', options)
}

export const goToFinancialPage = options => {
  goToPageInternal(getPrefixPath() + '/inkomsten', options)
}

export const goToContractPage = options => {
  goToPageInternal(getPrefixPath() + '/huurcontract', options)
}

export const goToDocumentPage = options => {
  goToPageInternal(getPrefixPath() + '/documenten', options)
}

export const goToProperViewBaseOnPhaseId = () => {
  const step = store.getState().FlowReducer.step
  const completedAt = store.getState().FlowReducer.completedAt

  if (step == 1 && completedAt == 1) {
    goToPageInternal(getPrefixPath() + '/bewoners')
  } else if (step == 1 && completedAt == 2) {
    goToPageInternal(getPrefixPath() + '/overzicht')
  } else if (step == 2 && completedAt == 2) {
    goToPageInternal(getPrefixPath() + '/start')
  } else {
    goToPageInternal(getPrefixPath() + '/overzicht')
  }
}

export const isBrusselsZipCode = zipCode => {
  if (!zipCode) return false
  const zipCodeAsNumber = Number(zipCode)
  return zipCodeAsNumber >= 1000 && zipCodeAsNumber < 1300
}

//completedAt -> step
// const pathsByIntakePhase = {
//   0: {
//     none: {
//       allowedPaths: [
//         '/start',
//         '/bewoners',
//         '/huurcontract',
//         '/huurintentie',
//         '/inkomsten',
//         '/documenten',
//         '/profiel',
//         '/profiel/',
//       ],
//       defaultVirginPath: '/start',
//       defaultPath: '/profiel',
//     },
//     0: {
//       allowedPaths: [
//         '/start',
//         '/bewoners',
//         '/huurcontract',
//         '/huurintentie',
//         '/inkomsten',
//         '/documenten',
//         '/overzicht',
//         '/opnieuw',
//         '/bedankt',
//         '/profiel',
//         '/profiel/',
//       ],
//       defaultVirginPath: '/start',
//       defaultPath: '/overzicht',
//     },
//   },
//   1: {
//     1: {
//       allowedPaths: ['/bewoners', '/huurintentie', '/inkomsten', '/overzicht', '/profiel', '/profiel/'],
//       defaultVirginPath: '/bewoners',
//       defaultPath: '/overzicht',
//     },
//     0: {
//       allowedPaths: ['/opnieuw', '/bedankt', '/profiel', '/profiel/'],
//       defaultVirginPath: '/opnieuw',
//       defaultPath: '/profiel',
//     },
//   },
//   2: {
//     1: {
//       allowedPaths: ['/opnieuw', '/bedankt', '/profiel', '/profiel/'],
//       defaultVirginPath: '/profiel',
//       defaultPath: '/profiel',
//     },
//     2: {
//       allowedPaths: [
//         '/start',
//         '/bewoners',
//         '/huurcontract',
//         '/huurintentie',
//         '/inkomsten',
//         '/documenten',
//         '/overzicht',
//         '/profiel',
//         '/bedankt',
//         '/profiel/',
//       ],
//       defaultVirginPath: '/start',
//       defaultPath: '/overzicht',
//     },
//   },
//   3: {
//     2: {
//       allowedPaths: ['/opnieuw', '/bedankt', '/profiel', '/profiel/'],
//       defaultVirginPath: '/profiel',
//       defaultPath: '/profiel',
//     },
//   },
// }
/**
 * STEP:
 *
 * 1: bezoekaanvraag
 * 2: huuraanvraag
 * 3: kandidaat huurder
 * 4: afgewezen huurder
 */
const getPathsByStep = zipCode => {
  const isZipCodeFromBrussels = isBrusselsZipCode(zipCode)
  return {
    // Niet via pand
    GENERAL_STEPS: {
      allowedPaths: [
        '/start',
        '/bewoners',
        '/huurcontract',
        '/huurintentie',
        '/inkomsten',
        '/documenten',
        '/profiel',
        '/profiel/',
      ],
      defaultVirginPath: '/start',
      defaultPath: '/profiel',
    },
    // Bezoekaanvraag
    VISIT_REQUEST_STEPS: {
      allowedPaths: isZipCodeFromBrussels
        ? ['/bewoners', '/inkomsten', '/overzicht', '/bedankt', '/profiel', '/profiel/']
        : ['/bewoners', '/huurintentie', '/inkomsten', '/overzicht', '/bedankt', '/profiel', '/profiel/'],
      defaultVirginPath: isZipCodeFromBrussels ? '/huurintentie' : '/bewoners',
      defaultPath: '/overzicht',
    },
    // Huuraanvraag
    CANDIDACY_REQUEST_STEPS: {
      allowedPaths: [
        '/start',
        '/bewoners',
        '/huurcontract',
        '/huurintentie',
        '/inkomsten',
        '/documenten',
        '/overzicht',
        '/profiel',
        '/bedankt',
        '/profiel/',
      ],
      defaultVirginPath: '/start',
      defaultPath: '/overzicht',
    },
    TENANT_STEPS: {
      allowedPaths: ['/opnieuw', '/bedankt', '/profiel', '/profiel/'],
      defaultVirginPath: '/opnieuw',
      defaultPath: '/opnieuw',
    },
    REJECTED_STEPS: {
      allowedPaths: ['/opnieuw', '/bedankt', '/profiel', '/profiel/'],
      defaultVirginPath: '/opnieuw',
      defaultPath: '/opnieuw',
    },
  }
}

const completedPaths = {
  allowedPaths: ['/opnieuw', '/bedankt', '/profiel', '/profiel/'],
  defaultVirginPath: '/opnieuw',
  defaultPath: '/opnieuw',
}

export const redirectByPhase = (step, completedAt, finishedStep, zipCode) => {
  const stepType = getCurrentStepType(step)
  const currentPath = getCurrentPath()
  const isCompleted = !!completedAt
  const defaultPath = finishedStep[step] ? 'defaultPath' : 'defaultVirginPath'
  const pathsByStep = getPathsByStep(zipCode)
  const pathsObject = isCompleted ? completedPaths : pathsByStep[stepType]

  dump({ stepType, completedAt, isCompleted, step, finishedStep, currentPath, defaultPath, pathsObject })

  if (!pathsObject.allowedPaths.includes(currentPath)) {
    const path = `${getPrefixPath()}${pathsObject[defaultPath]}`
    dump({ path })

    goToPageInternal(path)
  }
}



// WEBPACK FOOTER //
// ./src/services/routeService.js